import React, { useState, useRef, useEffect, useCallback } from 'react'
import classnames from 'classnames'

import styles from './ButtonWithMenu.scss'
import { useViewport } from 'mailup-react-helpers'
import styled from '@emotion/styled'

const {
  rootClass: CLASSNAME_ROOT,
  rootOpenClass: CLASSNAME_ROOT_OPEN,
  buttonClass: CLASSNAME_BUTTON,
  menuClass: CLASSNAME_MENU
} = styles

export const makeButtonWithMenu = (ButtonComponent, MenuComponent, id) => ({
  className,
  'data-mu-test': dataAttributeTest,
  direction
}) => {
  const StyledContainer = styled.div`
    ${({ height }) =>
      correctDirection === 'middle'
        ? `
        .c-button-with-menu__menu {
          top: ${(height / 2) * -1 + 13}px !important;

          &::after{
            top: auto !important;
            bottom: ${height / 2 - 10}px !important;
          }
        }
       
      `
        : correctDirection === 'down'
        ? `
        .c-button-with-menu__menu {
          top: -15px !important;

          &::after{
            top: 18 !important;
            
          }
        }
       
      `
        : correctDirection === 'up'
        ? `
        .c-button-with-menu__menu {
          top: ${height * -1 + 40}px !important;


          &::after{
            top: auto !important;
            bottom: 18px !important;
          }
        }
      `
        : ` `}
  `

  const [correctDirection, setCorrectDirection] = useState(direction || 'down')
  const element = useRef(null)

  const [open, setOpen] = useState(false)

  const [viewport] = useViewport({
    scroll: (e, viewport) => {
      windowHeight.current = viewport.windowHeight
    },
    resize: (e, viewport) => {
      windowHeight.current = viewport.windowHeight
    }
  })
  const windowHeight = useRef(viewport.windowHeight)

  const [heightMenu, setHeightMenu] = useState(0)

  const elementMenu = useCallback(node => {
    if (node !== null) {
      setHeightMenu(node.getBoundingClientRect().height)
    }
  }, [])

  const { current: handleClickOutside } = useRef(e => {
    if (element.current && !element.current.contains(e.target)) {
      setOpen(false)
    }
  })

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, { capture: true })
    const clear = () => {
      document.removeEventListener('click', handleClickOutside, {
        capture: true
      })
    }
    return clear
  }, [])

  const toggle = () => {
    setOpen(prev => !prev)
  }

  return (
    <StyledContainer
      height={heightMenu}
      className={classnames(CLASSNAME_ROOT, className, {
        [CLASSNAME_ROOT_OPEN]: open
      })}
      onClick={toggle}
      ref={element}
      data-mu-test={dataAttributeTest}
    >
      <div
        className={CLASSNAME_BUTTON}
        onClick={e => {
          if (direction) {
            return
          }
          const altezzaFinestra = windowHeight.current
          const clickUtente = e.clientY
          if (clickUtente < heightMenu) {
            if (altezzaFinestra - clickUtente < heightMenu) {
              setCorrectDirection('middle')
            } else {
              setCorrectDirection('down')
            }
          } else {
            if (altezzaFinestra - clickUtente > heightMenu) {
              setCorrectDirection('down')
            } else {
              setCorrectDirection('up')
            }
          }
        }}
      >
        <ButtonComponent className='c-button-with-menu__button' />
      </div>
      <div className={CLASSNAME_MENU} ref={elementMenu}>
        <MenuComponent className='c-button-with-menu__menu' />
      </div>
    </StyledContainer>
  )
}
